// Nikura Custom Code - Product Page buy box / add-ons / FAQ events - Start
// Colleagues' tracking sheet 12fQI2GIr--PPuhdRlWcwHGRcE0g8g4mwC1ctyWbuf5U rows 11-14, 16, 17 (columns E-H).
// Pushes one flat dataLayer event per interaction (the house 'NK dL' field style); GTM custom-event
// triggers map each event to a GA4 tag. Only top-level overlap with existing tags is `currency`
// (always 'GBP', the shop currency).
//   pdp_addon_select        - 'Popular add-ons' card ticked / unticked
//   pdp_addon_carousel_nav  - add-on carousel arrow, dot or swipe that changes the page
//   pdp_quantity_change     - buy box - / + quantity buttons
//   pdp_add_to_cart         - main ADD TO BASKET button (click intent, not the sticky bar)
//   pdp_faq_toggle          - FAQ question opened / closed
//   pdp_faq_load_more       - FAQ LOAD MORE link
// Strict no-op: only product pages, and each listener only acts on its own element. No network
// calls, no customer data. SKUs come from data Shopify already printed on the page.

(function () {
  'use strict';

  if (window.__nkPdpEvInstalled) return;
  window.__nkPdpEvInstalled = true;
  if (window.location.pathname.indexOf('/products/') === -1) return;

  var SETTLE_MS = 400;
  var CAROUSEL = '.misti-upsell-wrapper';
  var SLIDE = '.misti-product-upsell';
  var ADDON_BOX = 'input[name="misti-product-upsell"]';

  function text(el) { return el ? (el.textContent || '').replace(/\s+/g, ' ').trim() : ''; }
  function money(s) {
    var m = String(s || '').replace(/,/g, '').match(/\d+(?:\.\d{1,2})?/);
    return m ? Number(m[0]) : undefined;
  }
  function visible(el) { return !!(el && el.getClientRects().length); }
  function push(event, fields) {
    var payload = { event: event };
    for (var k in fields) if (Object.prototype.hasOwnProperty.call(fields, k)) payload[k] = fields[k];
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
  }

  // ---- product data already on the page ----
  function metaProduct() {
    var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
    return meta && meta.product ? meta.product : null;
  }
  function form() {
    var atc = document.getElementById('addToCart');
    return atc ? atc.closest('form') : null;
  }
  function selectedVariantId() {
    var f = form();
    var input = f && f.querySelector('input[name="id"]');
    if (input && input.value) return String(input.value);
    var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
    return meta && meta.selectedVariantId ? String(meta.selectedVariantId) : '';
  }
  // The buy box's own live state (Alpine `product.selected`): the only source every product
  // template has (AIRI / starter kit have no form id input and no meta.selectedVariantId).
  function buyBoxSelected() {
    var atc = document.getElementById('addToCart');
    for (var el = atc; el; el = el.parentElement) {
      var stack = el._x_dataStack;
      if (!stack) continue;
      for (var i = 0; i < stack.length; i++) {
        var sel = stack[i] && stack[i].product && stack[i].product.selected;
        if (sel && sel.id) return sel;
      }
    }
    return null;
  }
  function parent() {
    var p = metaProduct();
    var live = buyBoxSelected();
    var vid = live ? String(live.id) : selectedVariantId();
    var variant = null;
    if (p && p.variants) {
      for (var i = 0; i < p.variants.length; i++) {
        if (String(p.variants[i].id) === vid) { variant = p.variants[i]; break; }
      }
    }
    return {
      item_id: (variant && variant.sku) || (live && live.sku) || vid || (p ? String(p.id) : ''),
      item_name: text(document.querySelector('h1')),
      unit_price: variant && typeof variant.price === 'number' ? variant.price / 100 : undefined
    };
  }

  // Shopify's own page-load product JSON lists each add-on variant with its SKU and full title.
  // Shape: {"title":"<product>","url":"\/products\/..",...,"variants":[{"id":"<vid>",...,"sku":"<sku>",..}]}
  var addonCache = {};
  function addonInfo(variantId) {
    var vid = String(variantId || '');
    if (!vid) return null;
    if (vid in addonCache) return addonCache[vid];
    var found = null;
    var scripts = document.getElementsByTagName('script');
    for (var s = 0; s < scripts.length && !found; s++) {
      var src = scripts[s].textContent || '';
      var at = src.indexOf('"id":"' + vid + '"');
      if (at === -1) continue;
      var sku = /"sku":"([^"]*)"/.exec(src.slice(at, at + 600));
      var urlAt = src.lastIndexOf('","url":"\\/products\\/', at);
      var titleAt = urlAt === -1 ? -1 : src.lastIndexOf('"title":"', urlAt);
      var title = '';
      var raw = titleAt === -1 ? null : /^"title":("(?:[^"\\]|\\.)*")/.exec(src.slice(titleAt, urlAt + 2));
      if (raw) {
        try { title = JSON.parse(raw[1]); } catch (e) { title = ''; }
      }
      if (sku) found = { sku: sku[1], title: title };
    }
    addonCache[vid] = found;
    return found;
  }

  // ---- add-ons ----
  function realSlides() {
    var wrap = document.querySelector(CAROUSEL);
    if (!wrap) return [];
    return Array.prototype.filter.call(wrap.querySelectorAll(SLIDE), function (s) {
      return !s.classList.contains('splide__slide--clone');
    });
  }
  // One-based position of the ORIGINAL slide for this checkbox id (Splide clones share the id).
  function addonPosition(boxId) {
    var slides = realSlides();
    for (var i = 0; i < slides.length; i++) {
      var b = slides[i].querySelector(ADDON_BOX);
      if (b && b.id === boxId) return i + 1;
    }
    return undefined;
  }
  function checkedAddonSkus() {
    var seen = {}, out = [];
    realSlides().forEach(function (slide) {
      var b = slide.querySelector(ADDON_BOX);
      if (!b || !b.id || seen[b.id]) return;
      var anyChecked = Array.prototype.some.call(
        document.querySelectorAll(ADDON_BOX + '[id="' + b.id + '"]'), function (x) { return x.checked; });
      if (!anyChecked) return;
      seen[b.id] = true;
      var info = addonInfo(b.id);
      out.push(info && info.sku ? info.sku : b.id);
    });
    return out.join(',');
  }

  document.addEventListener('change', function (e) {
    var box = e.target;
    if (!box || !box.matches || !box.matches(ADDON_BOX) || !box.closest(CAROUSEL)) return;
    var slide = box.closest(SLIDE);
    var info = addonInfo(box.id);
    var p = parent();
    push('pdp_addon_select', {
      location_id: 'pdp_addons',
      action: box.checked ? 'select' : 'deselect',
      parent_item_id: p.item_id,
      parent_item_name: p.item_name,
      addon_item_id: info && info.sku ? info.sku : box.id,
      addon_item_name: info && info.title ? info.title : text(slide && slide.querySelector('.upsell-name')),
      addon_price: money(text(slide && (slide.querySelector('.upsell-price .text-black') || slide.querySelector('.upsell-price')))),
      addon_position: addonPosition(box.id)
    });
  }, true);

  // ---- add-on carousel ----
  function activePage(wrap) {
    var dots = wrap ? wrap.querySelectorAll('.misti-upsell-pagination .misti-dot') : [];
    for (var i = 0; i < dots.length; i++) if (dots[i].classList.contains('is-active')) return i + 1;
    return undefined;
  }
  var navPending = null;   // {type, direction, from} set by a human pointer on the carousel
  function reportNav(wrap) {
    if (!navPending) return;
    var page = activePage(wrap);
    if (page === undefined || page === navPending.from) return;
    var pending = navPending;
    navPending = null;
    var direction = pending.direction || (page > pending.from ? 'next' : 'prev');
    push('pdp_addon_carousel_nav', {
      location_id: 'pdp_addons',
      interaction_type: pending.type,
      direction: direction,
      page_index: page,
      item_id: parent().item_id
    });
  }
  document.addEventListener('pointerdown', function (e) {
    var wrap = e.target && e.target.closest ? e.target.closest(CAROUSEL) : null;
    if (!wrap) return;
    var arrow = e.target.closest('.misti-upsell-prev, .misti-upsell-next');
    var dot = e.target.closest('.misti-upsell-pagination .misti-dot');
    var type = arrow ? 'arrow' : (dot ? 'dot' : 'swipe');
    var direction = arrow ? (arrow.classList.contains('misti-upsell-next') ? 'next' : 'prev') : '';
    var started = navPending = { type: type, direction: direction, from: activePage(wrap) };
    // Arrows/dots: report once the page settles. Swipes: the dot observer reports the change.
    setTimeout(function () { if (navPending === started && type !== 'swipe') reportNav(wrap); }, SETTLE_MS);
    setTimeout(function () { if (navPending === started) navPending = null; }, 2000);
  }, true);
  function watchDots() {
    var wrap = document.querySelector(CAROUSEL);
    var list = wrap && wrap.querySelector('.misti-upsell-pagination');
    if (!list || list.__nkObserved) return !!list;
    list.__nkObserved = true;
    new MutationObserver(function () { reportNav(wrap); })
      .observe(list, { subtree: true, attributes: true, attributeFilter: ['class'], childList: true });
    return true;
  }
  if (!watchDots()) document.addEventListener('DOMContentLoaded', watchDots);
  window.addEventListener('load', watchDots);

  // ---- buy box, FAQ ----
  function qtyValue() {
    var q = document.getElementById('product-qty');
    var n = q ? parseInt(q.value, 10) : NaN;
    return isFinite(n) ? n : 1;
  }
  function purchaseOption() {
    var picked = document.querySelector('.loop-widget-purchase-option-selected, [data-loop-widget-purchase-option][aria-checked="true"]');
    if (picked) return picked.hasAttribute('data-loop-widget-onetime-purchase-option') ? 'one_time' : 'subscribe_and_save';
    var f = form();
    var plan = f && f.querySelector('input[name="selling_plan"]');
    return plan && plan.value ? 'subscribe_and_save' : 'one_time';
  }
  function unitPrice() {
    var picked = document.querySelector('.loop-widget-purchase-option-selected .loop-widget-purchase-option-price, [data-loop-widget-purchase-option][aria-checked="true"] .loop-widget-purchase-option-price');
    var shown = money(text(picked));
    return shown !== undefined ? shown : parent().unit_price;
  }
  function faqItems() {
    var faq = document.getElementById('faq-section');
    return faq ? Array.prototype.slice.call(faq.querySelectorAll('.accordion-item')) : [];
  }
  function faqOpen(item) {
    var desc = item.querySelector('.accordion-desc');
    return !!(desc && desc.getBoundingClientRect().height > 1);
  }
  function visibleFaqCount() { return faqItems().filter(visible).length; }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    var qtyBtn = t.closest('.quantity-selector .decreasev2, .quantity-selector .increasev2');
    if (qtyBtn && qtyBtn.closest('form') === form()) {
      var button = qtyBtn.classList.contains('increasev2') ? 'plus' : 'minus';
      setTimeout(function () {
        var p = parent();
        push('pdp_quantity_change', { location_id: 'pdp_buy_box', button: button, quantity: qtyValue(), item_id: p.item_id, item_name: p.item_name });
      }, 0);
      return;
    }

    var atc = t.closest('#addToCart');
    if (atc) {
      if (/sold out/i.test(text(atc))) return;
      var p = parent();
      var qty = qtyValue();
      var unit = unitPrice();
      push('pdp_add_to_cart', {
        location_id: 'pdp_buy_box',
        add_source: 'main_button',
        currency: 'GBP',
        value: unit !== undefined ? Math.round(unit * qty * 100) / 100 : undefined,
        item_id: p.item_id,
        item_name: p.item_name,
        purchase_option: purchaseOption(),
        quantity: qty,
        addons: checkedAddonSkus()
      });
      return;
    }

    var header = t.closest('#faq-section .accordion-header');
    if (header) {
      var item = header.closest('.accordion-item');
      var items = faqItems();
      var wasOpen = faqOpen(item);
      setTimeout(function () {
        var nowOpen = faqOpen(item);
        push('pdp_faq_toggle', {
          location_id: 'pdp_faq',
          action: (nowOpen === wasOpen ? !wasOpen : nowOpen) ? 'open' : 'close',
          faq_question: text(header),
          faq_position: items.indexOf(item) + 1,
          item_id: parent().item_id
        });
      }, SETTLE_MS);
      return;
    }

    if (t.closest('#faq-load-more')) {
      var before = visibleFaqCount();
      setTimeout(function () {
        push('pdp_faq_load_more', { location_id: 'pdp_faq', rows_before: before, rows_after: visibleFaqCount(), item_id: parent().item_id });
      }, SETTLE_MS);
    }
  }, true);
})();
// Nikura Custom Code - Product Page buy box / add-ons / FAQ events - End
